'use strict';

var App = require('app');
var Alarm = require('utils/alarm');
var AppState = require('app_state');
var Consts = require('consts');
var I18N = require('utils/i18n');
var Misc = require('utils/misc');

var AlarmOccurrenceView = require('components/devices/views/alarm/alarm_occurrence_view');

var groupFilterFct = {
    None: function (g) {
        return {};
    },
    Interval: function (g) {
        var filter = Misc.cloneAsJSON(g.settings);
        var utc = Math.floor(new Date().getTime() / 1000);
        _.each(['from', 'till'], function (key) {
            filter[key] = filter[key] ? utc + filter[key] * 60 : undefined;
        });
        return filter;
    },
    Cond: function (g) {
        if (g.line1 == Consts.AlarmStatusField) {
            return { status: g.value, category: g.category };
        }
        return { cond: g.key };
    },
    Name: function (g) {
        if (g.key) return { alarm_prefix: g.key };
        return { alarm: g.name };
    },
    Prio: function (g) {
        return { priority: g.prio };
    },
    Device: function (g) {
        if (g.key) return { device_prefix: g.key };

        return { device: g.name };
    },
};

var AlarmGroupList = Marionette.LayoutView.extend({
    template: require('components/devices/templates/alarm/alarm_group_list'),
    ui: {
        ddlGroupBy: '#alarm-group',
        ddlAcknowledge: '#alarm-acknowledge',
        ddlTriggered: '#alarm-triggered',
    },
    config: {},
    events: {
        'change #alarm-group': function (e) {
            this.config.group = this.ui.ddlGroupBy.val();
            this.loadGroupList();
        },
        'hide.bs.select select.js-alarm-filter': function (e) {
            this.refreshFilter();
        },
        'click .js-alarm-list-refresh': function () {
            this.loadGroupList();
        },
    },

    emptyView: function () {
        var template = require('components/common/templates/message');
        return template({
            title: I18N.TR('Keine Alarme gefunden'),
            text: I18N.TR('Es wurden keine Alarme gefunden, die Ihrer Filtereinstellung entsprechen.'),
        });
    },

    getFilterMode: function (fv) {
        return !fv || !fv.length || fv.length == 2 ? 1 : fv[0] == 1 ? 2 : 0; /* 0-not ack only, 1- */
    },

    refreshFilter: function () {
        this.config.ackValue = this.ui.ddlAcknowledge.val();
        this.config.triggeredValue = this.ui.ddlTriggered.val();
        this.config.ackMode = this.getFilterMode(this.config.ackValue);
        this.config.triggeredMode = this.getFilterMode(this.config.triggeredValue);
        this.loadGroupList();
    },

    serializeData: function () {
        var self = this;
        var currentGroupSettings = Misc.selectWhereFirst(this.options.groupSettings, function (item) {
            return item.key == self.config.group;
        });

        return {
            groupSettings: this.options.groupSettings,
            config: this.config,
            groups: _.sortBy(this.groups, function (item) {
                var sortCol = currentGroupSettings.sortCol;
                return sortCol ? item[sortCol] : item.name;
            }),
            filter: { ackValue: this.config.ackValue, triggeredValue: this.config.triggeredValue },
            emptyView: this.groups && !this.groups.length ? this.emptyView() : undefined,
        };
    },

    initialize: function (data) {
        this.ownerID = data.ownerID;
        this.controller = data.controller;
        this.config = {
            group: 'Interval',
            ackMode: 1,
            triggeredMode: 1,
        };
    },

    loadGroupList: function () {
        var self = this;
        var grpType = this.config.group;
        var grpInfo = Consts.AlarmGroups[grpType];
        if (grpInfo.groups) {
            this.loadGroups(grpInfo.groups);
            return;
        }

        var idx = grpInfo.idx;
        if (idx == undefined) return;

        $.when(App.request('alarm-occurrences:groups', idx, this.ownerID)).done(function (items) {
            self.loadGroups(self.createGroups(items));
        });
    },

    createGroups: function (items) {
        switch (this.config.group) {
            case 'Prio':
                return _.map(items, function (item) {
                    return { prio: item.name, name: Alarm.getPriorityText(item.name), order: -parseInt(item.name) };
                });
            case 'Cond':
                var result = [];
                var statusConds = {};

                _.each(items, function (item) {
                    // is it non-status condition? Use it as it is
                    if (item.line1 != Consts.AlarmStatusField) {
                        result.push(item);
                        return;
                    }

                    // go through all bits or values
                    var bits = Alarm.decodeStatus(item.value);
                    _.each(bits, function (bit) {
                        var category = bit > 0 && item.category ? item.category : undefined;
                        var key = (category || '') + bit;
                        if (!statusConds[key]) {
                            result.push({
                                line1: Consts.AlarmStatusField,
                                value: bit,
                                category: category,
                                filter: category ? { category: [category] } : {},
                            });
                            statusConds[key] = true;
                        }
                    });
                });

                return result;

            default:
                return _.map(items, function (item) {
                    return { name: item.name, key: item.key };
                });
        }
    },

    getGroupRequest: function (grp) {
        var fct = groupFilterFct[this.config.group];
        if (!fct) return undefined;
        var filter = fct(grp);
        if (filter) {
            filter.sort_col = 'trigger_time';
            filter.sort_desc = true;
            filter.limit = AppState.getItemsPerPage();
            filter.ack_mode = this.config.ackMode;
            filter.triggered_mode = this.config.triggeredMode;
            if (this.ownerID) {
                filter.device_id = this.ownerID;
            }
            return App.request('alarm-occurrences:list', filter, grp);
        }
        return undefined;
    },

    loadGroups: function (groups) {
        var self = this;
        var reqs = _.map(groups, function (grp) {
            return self.getGroupRequest(grp);
        });
        $.when.apply($, reqs).done(function () {
            // build groups
            $.when(self.updateGroups(arguments)).done(function () {
                self.render();
                self.updateRegions();
            });
        });
    },

    getNameFromKey: function (key, result, grplink) {
        var gi = Consts.AlarmGroups[this.config.group];
        var list = _.uniq(
            _.map(result.items.models, function (m) {
                return m.get(gi.keyCol);
            })
        );

        if (list.length > 1) {
            grplink.mixed = true;
            return key + '...';
        }

        return list.length ? list[0] : '?';
    },

    updateGroups: function (dataResults) {
        var self = this;
        return Misc.deferredFct(function (defer) {
            this.groups = _.sortBy(
                _.compact(
                    _.map(dataResults, function (result, idx) {
                        if (!result.count) return undefined;
                        var newName = undefined;
                        // special treatment for condition
                        if (self.config.group == 'Cond') {
                            var ct = Alarm.getConditionText(result.grpLink, true, result.grpLink);
                            newName = ct.items && ct.items.length == 1 ? ct.items[0] : ct.text;
                        }

                        return {
                            name:
                                newName ||
                                result.grpLink.name ||
                                self.getNameFromKey(result.grpLink.key, result, result.grpLink),
                            region: 'grp-reg-' + idx,
                            result: result,
                            mixed: result.grpLink.mixed,
                            order: result.grpLink.order,
                        };
                    })
                ),
                function (item) {
                    return item.order !== undefined ? item.order : item.name;
                }
            );
            defer.resolve();
        }, this);
    },

    updateRegions: function () {
        var self = this;
        // delete old regions
        this.regionManager.removeRegions();

        // create new regions
        _.each(this.groups, function (grp) {
            self.regionManager.addRegion(grp.region, 'div#' + grp.region);
            self.showChildView(
                grp.region,
                new AlarmOccurrenceView({
                    controller: self.controller,
                    data: grp.result,
                    group: self.config.group,
                    mixed: grp.mixed,
                    isSmall: self.resizer.isSmall,
                })
            );
        });
    },

    onDestroy: function () {
        if (this.resizer) this.resizer.event.off();
    },

    onShow: function () {
        var self = this;

        Misc.initSelectPicker();
        this.loadGroupList();

        if (!this.resizer) {
            this.resizer = {
                previousWidth: undefined,
                threshold: 640,
                thrResize: Misc.throttle(
                    function () {
                        var width = $(window).width();
                        var isSmall = width <= self.resizer.threshold;
                        if (
                            self.resizer.previousWidth === undefined ||
                            isSmall != self.resizer.previousWidth <= self.resizer.threshold
                        ) {
                            self.resizer.isSmall = isSmall;
                            self.resizer.previousWidth = width;
                            self.updateRegions();
                        }
                    },
                    1,
                    1000
                ),
                event: Misc.toggleEvent(window, 'resize', function () {
                    self.resizer.thrResize();
                }),
            };
        }
        this.resizer.event.on(true);
    },

    onRender: function () {
        Misc.initSelectPicker();
    },
});

module.exports = AlarmGroupList;
